module.exports = __webpack_public_path__ + "img/Equipment.a133f69f.svg";